var map = {
	"./": 75967,
	"./Configuration": 54449,
	"./Configuration.js": 54449,
	"./Unknown": 21273,
	"./Unknown.js": 21273,
	"./UnknownClientSide": 44209,
	"./UnknownClientSide.js": 44209,
	"./UnknownClientSide.test": 30555,
	"./UnknownClientSide.test.js": 30555,
	"./chemistry/BandNode": 71891,
	"./chemistry/BandNode.js": 71891,
	"./chemistry/BoilingPointSolutionModeler": 90317,
	"./chemistry/BoilingPointSolutionModeler.js": 90317,
	"./chemistry/BoilingPointSolutionModeler.test": 41279,
	"./chemistry/BoilingPointSolutionModeler.test.js": 41279,
	"./chemistry/BunsenBurner": 7603,
	"./chemistry/BunsenBurner.js": 7603,
	"./chemistry/ColorCHSV": 72851,
	"./chemistry/ColorCHSV.js": 72851,
	"./chemistry/Constants": 64983,
	"./chemistry/Constants.js": 64983,
	"./chemistry/Constants.test": 12093,
	"./chemistry/Constants.test.js": 12093,
	"./chemistry/Cooling": 4921,
	"./chemistry/Cooling.js": 4921,
	"./chemistry/Cooling.test": 41667,
	"./chemistry/Cooling.test.js": 41667,
	"./chemistry/EquilibriumSettings": 68007,
	"./chemistry/EquilibriumSettings.js": 68007,
	"./chemistry/FreezingPointSolutionModeler": 40597,
	"./chemistry/FreezingPointSolutionModeler.js": 40597,
	"./chemistry/KnowledgeBase": 9599,
	"./chemistry/KnowledgeBase.js": 9599,
	"./chemistry/LiquidVolumeSolutionModeler": 55867,
	"./chemistry/LiquidVolumeSolutionModeler.js": 55867,
	"./chemistry/ReactionKinetics": 80631,
	"./chemistry/ReactionKinetics.js": 80631,
	"./chemistry/ReactionKinetics.test": 60957,
	"./chemistry/ReactionKinetics.test.js": 60957,
	"./chemistry/ReactionNodeHelpers.test": 47302,
	"./chemistry/ReactionNodeHelpers.test.js": 47302,
	"./chemistry/ReactionNodeKinetics": 84035,
	"./chemistry/ReactionNodeKinetics.js": 84035,
	"./chemistry/ReactionNodeKinetics.test": 13953,
	"./chemistry/ReactionNodeKinetics.test.js": 13953,
	"./chemistry/ReactionNodeKineticsNotes.md": 93936,
	"./chemistry/ReactionNodeTestGlucose.test": 79681,
	"./chemistry/ReactionNodeTestGlucose.test.js": 79681,
	"./chemistry/RungeKutta4": 77002,
	"./chemistry/RungeKutta4.js": 77002,
	"./chemistry/RungeKutta4.test": 53030,
	"./chemistry/RungeKutta4.test.js": 53030,
	"./chemistry/Solution": 81399,
	"./chemistry/Solution.js": 81399,
	"./chemistry/Solution.test": 95037,
	"./chemistry/Solution.test.js": 95037,
	"./chemistry/SolutionEq.test": 69071,
	"./chemistry/SolutionEq.test.js": 69071,
	"./chemistry/SolutionEqNonAq.test": 60804,
	"./chemistry/SolutionEqNonAq.test.js": 60804,
	"./chemistry/SolutionEqRedox.test": 59251,
	"./chemistry/SolutionEqRedox.test.js": 59251,
	"./chemistry/SolutionVessel.test": 70471,
	"./chemistry/SolutionVessel.test.js": 70471,
	"./chemistry/SolventConcentrationSolutionModeler": 12191,
	"./chemistry/SolventConcentrationSolutionModeler.js": 12191,
	"./chemistry/SolventSolutionModeler": 54752,
	"./chemistry/SolventSolutionModeler.js": 54752,
	"./chemistry/SpecieState": 57604,
	"./chemistry/SpecieState.js": 57604,
	"./chemistry/Species": 34944,
	"./chemistry/Species.js": 34944,
	"./chemistry/Species.test": 95448,
	"./chemistry/Species.test.js": 95448,
	"./chemistry/SpeciesNode": 69760,
	"./chemistry/SpeciesNode.js": 69760,
	"./chemistry/SpeciesNode.test": 68632,
	"./chemistry/SpeciesNode.test.js": 68632,
	"./chemistry/SpeciesNodeMoleFraction.test": 59611,
	"./chemistry/SpeciesNodeMoleFraction.test.js": 59611,
	"./chemistry/SpecificHeatSolutionMod": 45793,
	"./chemistry/SpecificHeatSolutionMod.js": 45793,
	"./chemistry/SpecificHeatSolutionMod.test": 28331,
	"./chemistry/SpecificHeatSolutionMod.test.js": 28331,
	"./chemistry/SpecificHeatSolutionModeler": 70259,
	"./chemistry/SpecificHeatSolutionModeler.js": 70259,
	"./chemistry/SpecificHeatSolutionModeler.test": 76401,
	"./chemistry/SpecificHeatSolutionModeler.test.js": 76401,
	"./chemistry/SpecificHeatSolutionModelerSolvent.test": 76298,
	"./chemistry/SpecificHeatSolutionModelerSolvent.test.js": 76298,
	"./chemistry/SpectrumColor": 39548,
	"./chemistry/SpectrumColor.js": 39548,
	"./chemistry/WeightSolutionModeler": 97301,
	"./chemistry/WeightSolutionModeler.js": 97301,
	"./chemistry/algoNotes1.txt": 40346,
	"./chemistry/getIndex": 93036,
	"./chemistry/getIndex.js": 93036,
	"./chemistry/sum": 58389,
	"./chemistry/sum.js": 58389,
	"./chemistry/testutils": 42355,
	"./chemistry/testutils.js": 42355,
	"./collections/Tool": 36267,
	"./collections/Tool.js": 36267,
	"./collections/Vessel": 17431,
	"./collections/Vessel.js": 17431,
	"./collections/Workbench": 41720,
	"./collections/Workbench.js": 41720,
	"./index": 75967,
	"./index.js": 75967,
	"./labInfo": 23604,
	"./labInfo.js": 23604,
	"./library": 66732,
	"./library.js": 66732,
	"./logging/XMLLogger": 67640,
	"./logging/XMLLogger.js": 67640,
	"./logging/XMLUtility": 12634,
	"./logging/XMLUtility.js": 12634,
	"./models/App": 7129,
	"./models/App.js": 7129,
	"./models/InstrumentPanel": 51387,
	"./models/InstrumentPanel.js": 51387,
	"./models/Solution": 69123,
	"./models/Solution.js": 69123,
	"./models/Tool": 35166,
	"./models/Tool.js": 35166,
	"./models/Vessel": 1622,
	"./models/Vessel.js": 1622,
	"./models/Workbench": 48491,
	"./models/Workbench.js": 48491,
	"./resources/assignment data translation.txt": 50620,
	"./resources/assignments": 42739,
	"./resources/assignments.js": 42739,
	"./resources/assignments/en/MolarityDensity/dilution/assignment": 90792,
	"./resources/assignments/en/MolarityDensity/dilution/assignment.json": 90792,
	"./resources/assignments/en/MolarityDensity/dilution/configuration": 75085,
	"./resources/assignments/en/MolarityDensity/dilution/configuration.json": 75085,
	"./resources/assignments/en/MolarityDensity/dilution/reactions": 34939,
	"./resources/assignments/en/MolarityDensity/dilution/reactions.json": 34939,
	"./resources/assignments/en/MolarityDensity/dilution/solutions": 71455,
	"./resources/assignments/en/MolarityDensity/dilution/solutions.json": 71455,
	"./resources/assignments/en/MolarityDensity/dilution/species": 1725,
	"./resources/assignments/en/MolarityDensity/dilution/species.json": 1725,
	"./resources/assignments/en/MolarityDensity/dilution/spectra": 60023,
	"./resources/assignments/en/MolarityDensity/dilution/spectra.json": 60023,
	"./resources/assignments/en/MolarityDensity/sucrose/assignment": 74752,
	"./resources/assignments/en/MolarityDensity/sucrose/assignment.json": 74752,
	"./resources/assignments/en/MolarityDensity/sucrose/configuration": 67509,
	"./resources/assignments/en/MolarityDensity/sucrose/configuration.json": 67509,
	"./resources/assignments/en/MolarityDensity/sucrose/reactions": 7251,
	"./resources/assignments/en/MolarityDensity/sucrose/reactions.json": 7251,
	"./resources/assignments/en/MolarityDensity/sucrose/solutions": 11447,
	"./resources/assignments/en/MolarityDensity/sucrose/solutions.json": 11447,
	"./resources/assignments/en/MolarityDensity/sucrose/species": 57685,
	"./resources/assignments/en/MolarityDensity/sucrose/species.json": 57685,
	"./resources/assignments/en/MolarityDensity/sucrose/spectra": 29183,
	"./resources/assignments/en/MolarityDensity/sucrose/spectra.json": 29183,
	"./resources/assignments/en/Redox/redox/assignment": 82215,
	"./resources/assignments/en/Redox/redox/assignment.json": 82215,
	"./resources/assignments/en/Redox/redox/configuration": 95592,
	"./resources/assignments/en/Redox/redox/configuration.json": 95592,
	"./resources/assignments/en/Redox/redox/reactions": 69630,
	"./resources/assignments/en/Redox/redox/reactions.json": 69630,
	"./resources/assignments/en/Redox/redox/solutions": 55778,
	"./resources/assignments/en/Redox/redox/solutions.json": 55778,
	"./resources/assignments/en/Redox/redox/species": 66856,
	"./resources/assignments/en/Redox/redox/species.json": 66856,
	"./resources/assignments/en/Redox/redox/spectra": 67706,
	"./resources/assignments/en/Redox/redox/spectra.json": 67706,
	"./resources/assignments/en/Redox/redox2/assignment": 46039,
	"./resources/assignments/en/Redox/redox2/assignment.json": 46039,
	"./resources/assignments/en/Redox/redox2/configuration": 72472,
	"./resources/assignments/en/Redox/redox2/configuration.json": 72472,
	"./resources/assignments/en/Redox/redox2/reactions": 9838,
	"./resources/assignments/en/Redox/redox2/reactions.json": 9838,
	"./resources/assignments/en/Redox/redox2/solutions": 242,
	"./resources/assignments/en/Redox/redox2/solutions.json": 242,
	"./resources/assignments/en/Redox/redox2/species": 70232,
	"./resources/assignments/en/Redox/redox2/species.json": 70232,
	"./resources/assignments/en/Redox/redox2/spectra": 82730,
	"./resources/assignments/en/Redox/redox2/spectra.json": 82730,
	"./resources/assignments/en/chem207/exp01/assignment": 61347,
	"./resources/assignments/en/chem207/exp01/assignment.json": 61347,
	"./resources/assignments/en/chem207/exp01/configuration": 69196,
	"./resources/assignments/en/chem207/exp01/configuration.json": 69196,
	"./resources/assignments/en/chem207/exp01/reactions": 89570,
	"./resources/assignments/en/chem207/exp01/reactions.json": 89570,
	"./resources/assignments/en/chem207/exp01/solutions": 84310,
	"./resources/assignments/en/chem207/exp01/solutions.json": 84310,
	"./resources/assignments/en/chem207/exp01/species": 15052,
	"./resources/assignments/en/chem207/exp01/species.json": 15052,
	"./resources/assignments/en/chem207/exp01/spectra": 23902,
	"./resources/assignments/en/chem207/exp01/spectra.json": 23902,
	"./resources/assignments/en/chemvlab/IV/IV_dilute_saline/assignment": 28393,
	"./resources/assignments/en/chemvlab/IV/IV_dilute_saline/assignment.json": 28393,
	"./resources/assignments/en/chemvlab/IV/IV_dilute_saline/configuration": 3474,
	"./resources/assignments/en/chemvlab/IV/IV_dilute_saline/configuration.json": 3474,
	"./resources/assignments/en/chemvlab/IV/IV_dilute_saline/reactions": 61124,
	"./resources/assignments/en/chemvlab/IV/IV_dilute_saline/reactions.json": 61124,
	"./resources/assignments/en/chemvlab/IV/IV_dilute_saline/solutions": 21848,
	"./resources/assignments/en/chemvlab/IV/IV_dilute_saline/solutions.json": 21848,
	"./resources/assignments/en/chemvlab/IV/IV_dilute_saline/species": 19478,
	"./resources/assignments/en/chemvlab/IV/IV_dilute_saline/species.json": 19478,
	"./resources/assignments/en/chemvlab/IV/IV_dilute_saline/spectra": 93352,
	"./resources/assignments/en/chemvlab/IV/IV_dilute_saline/spectra.json": 93352,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_12/assignment": 58539,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_12/assignment.json": 58539,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_12/configuration": 46148,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_12/configuration.json": 46148,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_12/reactions": 970,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_12/reactions.json": 970,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_12/solutions": 61470,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_12/solutions.json": 61470,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_12/species": 33972,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_12/species.json": 33972,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_12/spectra": 4502,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_12/spectra.json": 4502,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_18/assignment": 51573,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_18/assignment.json": 51573,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_18/configuration": 87782,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_18/configuration.json": 87782,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_18/reactions": 99112,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_18/reactions.json": 99112,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_18/solutions": 15612,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_18/solutions.json": 15612,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_18/species": 99178,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_18/species.json": 99178,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_18/spectra": 94940,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_18/spectra.json": 94940,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose/assignment": 610,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose/assignment.json": 610,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose/configuration": 59151,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose/configuration.json": 59151,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose/reactions": 2433,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose/reactions.json": 2433,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose/solutions": 45965,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose/solutions.json": 45965,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose/species": 3099,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose/species.json": 3099,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose/spectra": 75109,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose/spectra.json": 75109,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose2/assignment": 71912,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose2/assignment.json": 71912,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose2/configuration": 56557,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose2/configuration.json": 56557,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose2/reactions": 92347,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose2/reactions.json": 92347,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose2/solutions": 38303,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose2/solutions.json": 38303,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose2/species": 84669,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose2/species.json": 84669,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose2/spectra": 90519,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose2/spectra.json": 90519,
	"./resources/assignments/en/chemvlab/IV/IV_make_saline/assignment": 43000,
	"./resources/assignments/en/chemvlab/IV/IV_make_saline/assignment.json": 43000,
	"./resources/assignments/en/chemvlab/IV/IV_make_saline/configuration": 54717,
	"./resources/assignments/en/chemvlab/IV/IV_make_saline/configuration.json": 54717,
	"./resources/assignments/en/chemvlab/IV/IV_make_saline/reactions": 61163,
	"./resources/assignments/en/chemvlab/IV/IV_make_saline/reactions.json": 61163,
	"./resources/assignments/en/chemvlab/IV/IV_make_saline/solutions": 99823,
	"./resources/assignments/en/chemvlab/IV/IV_make_saline/solutions.json": 99823,
	"./resources/assignments/en/chemvlab/IV/IV_make_saline/species": 36781,
	"./resources/assignments/en/chemvlab/IV/IV_make_saline/species.json": 36781,
	"./resources/assignments/en/chemvlab/IV/IV_make_saline/spectra": 1671,
	"./resources/assignments/en/chemvlab/IV/IV_make_saline/spectra.json": 1671,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_a/assignment": 531,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_a/assignment.json": 531,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_a/configuration": 90780,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_a/configuration.json": 90780,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_a/reactions": 50674,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_a/reactions.json": 50674,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_a/solutions": 28390,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_a/solutions.json": 28390,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_a/species": 78652,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_a/species.json": 78652,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_a/spectra": 32526,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_a/spectra.json": 32526,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_b/assignment": 35108,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_b/assignment.json": 35108,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_b/configuration": 6033,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_b/configuration.json": 6033,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_b/reactions": 11247,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_b/reactions.json": 11247,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_b/solutions": 57747,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_b/solutions.json": 57747,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_b/species": 12129,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_b/species.json": 12129,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_b/spectra": 21259,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_b/spectra.json": 21259,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_a/assignment": 53408,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_a/assignment.json": 53408,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_a/configuration": 95253,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_a/configuration.json": 95253,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_a/reactions": 77651,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_a/reactions.json": 77651,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_a/solutions": 79095,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_a/solutions.json": 79095,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_a/species": 94773,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_a/species.json": 94773,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_a/spectra": 33407,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_a/spectra.json": 33407,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_b/assignment": 75535,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_b/assignment.json": 75535,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_b/configuration": 15360,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_b/configuration.json": 15360,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_b/reactions": 64230,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_b/reactions.json": 64230,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_b/solutions": 90474,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_b/solutions.json": 90474,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_b/species": 40848,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_b/species.json": 40848,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_b/spectra": 78514,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_b/spectra.json": 78514,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_c/assignment": 16718,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_c/assignment.json": 16718,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_c/configuration": 40787,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_c/configuration.json": 40787,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_c/reactions": 28037,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_c/reactions.json": 28037,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_c/solutions": 481,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_c/solutions.json": 481,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_c/species": 13263,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_c/species.json": 13263,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_c/spectra": 57993,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_c/spectra.json": 57993,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_a/assignment": 13801,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_a/assignment.json": 13801,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_a/configuration": 62770,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_a/configuration.json": 62770,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_a/reactions": 17476,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_a/reactions.json": 17476,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_a/solutions": 45368,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_a/solutions.json": 45368,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_a/species": 80054,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_a/species.json": 80054,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_a/spectra": 46440,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_a/spectra.json": 46440,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_b/assignment": 92502,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_b/assignment.json": 92502,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_b/configuration": 47435,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_b/configuration.json": 47435,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_b/reactions": 98573,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_b/reactions.json": 98573,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_b/solutions": 37033,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_b/solutions.json": 37033,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_b/species": 19895,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_b/species.json": 19895,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_b/spectra": 53377,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_b/spectra.json": 53377,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_c/assignment": 17975,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_c/assignment.json": 17975,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_c/configuration": 86328,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_c/configuration.json": 86328,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_c/reactions": 24846,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_c/reactions.json": 24846,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_c/solutions": 87186,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_c/solutions.json": 87186,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_c/species": 15288,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_c/species.json": 15288,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_c/spectra": 81578,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_c/spectra.json": 81578,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_d/assignment": 11348,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_d/assignment.json": 11348,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_d/configuration": 49665,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_d/configuration.json": 49665,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_d/reactions": 6431,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_d/reactions.json": 6431,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_d/solutions": 14755,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_d/solutions.json": 14755,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_d/species": 13649,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_d/species.json": 13649,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_d/spectra": 34043,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_d/spectra.json": 34043,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_e/assignment": 66917,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_e/assignment.json": 66917,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_e/configuration": 94422,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_e/configuration.json": 94422,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_e/reactions": 92504,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_e/reactions.json": 92504,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_e/solutions": 56684,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_e/solutions.json": 56684,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_e/species": 98778,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_e/species.json": 98778,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_e/spectra": 40620,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_e/spectra.json": 40620,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_a/assignment": 81254,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_a/assignment.json": 81254,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_a/configuration": 55259,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_a/configuration.json": 55259,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_a/reactions": 5917,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_a/reactions.json": 5917,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_a/solutions": 20633,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_a/solutions.json": 20633,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_a/species": 52967,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_a/species.json": 52967,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_a/spectra": 38129,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_a/spectra.json": 38129,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_b/assignment": 62361,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_b/assignment.json": 62361,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_b/configuration": 47682,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_b/configuration.json": 47682,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_b/reactions": 25876,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_b/reactions.json": 25876,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_b/solutions": 57352,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_b/solutions.json": 57352,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_b/species": 28089,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_b/species.json": 28089,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_b/spectra": 68696,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_b/spectra.json": 68696,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_c/assignment": 68984,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_c/assignment.json": 68984,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_c/configuration": 18621,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_c/configuration.json": 18621,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_c/reactions": 95051,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_c/reactions.json": 95051,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_c/solutions": 68079,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_c/solutions.json": 68079,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_c/species": 65165,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_c/species.json": 65165,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_c/spectra": 9095,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_c/spectra.json": 9095,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_d/assignment": 28179,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_d/assignment.json": 28179,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_d/configuration": 27580,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_d/configuration.json": 27580,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_d/reactions": 41458,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_d/reactions.json": 41458,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_d/solutions": 91974,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_d/solutions.json": 91974,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_d/species": 74076,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_d/species.json": 74076,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_d/spectra": 77966,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_d/spectra.json": 77966,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_ga/assignment": 5812,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_ga/assignment.json": 5812,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_ga/configuration": 81281,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_ga/configuration.json": 81281,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_ga/reactions": 40159,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_ga/reactions.json": 40159,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_ga/solutions": 37123,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_ga/solutions.json": 37123,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_ga/species": 21681,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_ga/species.json": 21681,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_ga/spectra": 47739,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_ga/spectra.json": 47739,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_precip/assignment": 52213,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_precip/assignment.json": 52213,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_precip/configuration": 36038,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_precip/configuration.json": 36038,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_precip/reactions": 57224,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_precip/reactions.json": 57224,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_precip/solutions": 75068,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_precip/solutions.json": 75068,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_precip/species": 44458,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_precip/species.json": 44458,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_precip/spectra": 33148,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_precip/spectra.json": 33148,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_ga/assignment": 62842,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_ga/assignment.json": 62842,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_ga/configuration": 89495,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_ga/configuration.json": 89495,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_ga/reactions": 77625,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_ga/reactions.json": 77625,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_ga/solutions": 85957,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_ga/solutions.json": 85957,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_ga/species": 99795,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_ga/species.json": 99795,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_ga/spectra": 73485,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_ga/spectra.json": 73485,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_precip/assignment": 57791,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_precip/assignment.json": 57791,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_precip/configuration": 60784,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_precip/configuration.json": 60784,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_precip/reactions": 53078,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_precip/reactions.json": 53078,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_precip/solutions": 79098,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_precip/solutions.json": 79098,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_precip/species": 70080,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_precip/species.json": 70080,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_precip/spectra": 88866,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_precip/spectra.json": 88866,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt/assignment": 98148,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt/assignment.json": 98148,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt/configuration": 54577,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt/configuration.json": 54577,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt/reactions": 76431,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt/reactions.json": 76431,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt/solutions": 99827,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt/solutions.json": 99827,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt/species": 25505,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt/species.json": 25505,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt/spectra": 24875,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt/spectra.json": 24875,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt2/assignment": 21330,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt2/assignment.json": 21330,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt2/configuration": 52575,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt2/configuration.json": 52575,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt2/reactions": 35825,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt2/reactions.json": 35825,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt2/solutions": 80125,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt2/solutions.json": 80125,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt2/species": 90635,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt2/species.json": 90635,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt2/spectra": 72213,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt2/spectra.json": 72213,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold1/assignment": 94245,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold1/assignment.json": 94245,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold1/configuration": 32534,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold1/configuration.json": 32534,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold1/reactions": 42104,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold1/reactions.json": 42104,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold1/solutions": 85452,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold1/solutions.json": 85452,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold1/species": 70522,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold1/species.json": 70522,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold1/spectra": 6828,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold1/spectra.json": 6828,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold2/assignment": 61010,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold2/assignment.json": 61010,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold2/configuration": 40479,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold2/configuration.json": 40479,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold2/reactions": 85105,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold2/reactions.json": 85105,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold2/solutions": 54845,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold2/solutions.json": 54845,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold2/species": 92715,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold2/species.json": 92715,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold2/spectra": 26101,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold2/spectra.json": 26101,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar1/assignment": 28669,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar1/assignment.json": 28669,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar1/configuration": 29182,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar1/configuration.json": 29182,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar1/reactions": 91120,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar1/reactions.json": 91120,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar1/solutions": 48708,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar1/solutions.json": 48708,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar1/species": 96210,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar1/species.json": 96210,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar1/spectra": 94228,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar1/spectra.json": 94228,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar2/assignment": 35370,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar2/assignment.json": 35370,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar2/configuration": 51847,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar2/configuration.json": 51847,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar2/reactions": 54665,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar2/reactions.json": 54665,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar2/solutions": 36053,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar2/solutions.json": 36053,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar2/species": 48931,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar2/species.json": 48931,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar2/spectra": 27197,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar2/spectra.json": 27197,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim1/assignment": 61550,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim1/assignment.json": 61550,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim1/configuration": 44467,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim1/configuration.json": 44467,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim1/reactions": 88421,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim1/reactions.json": 88421,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim1/solutions": 63649,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim1/solutions.json": 63649,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim1/species": 85615,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim1/species.json": 85615,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim1/spectra": 44073,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim1/spectra.json": 44073,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim2/assignment": 16033,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim2/assignment.json": 16033,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim2/configuration": 40890,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim2/configuration.json": 40890,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim2/reactions": 3004,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim2/reactions.json": 3004,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim2/solutions": 44848,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim2/solutions.json": 44848,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim2/species": 6286,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim2/species.json": 6286,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim2/spectra": 43824,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim2/spectra.json": 43824,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim3/assignment": 58048,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim3/assignment.json": 58048,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim3/configuration": 17493,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim3/configuration.json": 17493,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim3/reactions": 24083,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim3/reactions.json": 24083,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim3/solutions": 28279,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim3/solutions.json": 28279,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim3/species": 12213,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim3/species.json": 12213,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim3/spectra": 83711,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim3/spectra.json": 83711,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim4/assignment": 81115,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim4/assignment.json": 81115,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim4/configuration": 56404,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim4/configuration.json": 56404,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim4/reactions": 86362,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim4/reactions.json": 86362,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim4/solutions": 81806,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim4/solutions.json": 81806,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim4/species": 84676,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim4/species.json": 84676,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim4/spectra": 51142,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim4/spectra.json": 51142,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim5/assignment": 35050,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim5/assignment.json": 35050,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim5/configuration": 56071,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim5/configuration.json": 56071,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim5/reactions": 43977,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim5/reactions.json": 43977,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim5/solutions": 88181,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim5/solutions.json": 88181,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim5/species": 72035,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim5/species.json": 72035,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim5/spectra": 38173,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim5/spectra.json": 38173,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim6/assignment": 28381,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim6/assignment.json": 28381,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim6/configuration": 9118,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim6/configuration.json": 9118,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim6/reactions": 45456,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim6/reactions.json": 45456,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim6/solutions": 58276,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim6/solutions.json": 58276,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim6/species": 78482,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim6/species.json": 78482,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim6/spectra": 33524,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim6/spectra.json": 33524,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim7/assignment": 98668,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim7/assignment.json": 98668,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim7/configuration": 49705,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim7/configuration.json": 49705,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim7/reactions": 25143,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim7/reactions.json": 25143,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim7/solutions": 42939,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim7/solutions.json": 42939,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim7/species": 22921,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim7/species.json": 22921,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim7/spectra": 54979,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim7/spectra.json": 54979,
	"./resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/assignment": 44612,
	"./resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/assignment.json": 44612,
	"./resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/configuration": 54865,
	"./resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/configuration.json": 54865,
	"./resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/reactions": 16367,
	"./resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/reactions.json": 16367,
	"./resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/solutions": 39763,
	"./resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/solutions.json": 39763,
	"./resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/species": 8705,
	"./resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/species.json": 8705,
	"./resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/spectra": 8075,
	"./resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/spectra.json": 8075,
	"./resources/assignments/en/colligative/bp_elevation/assignment": 74320,
	"./resources/assignments/en/colligative/bp_elevation/assignment.json": 74320,
	"./resources/assignments/en/colligative/bp_elevation/configuration": 95109,
	"./resources/assignments/en/colligative/bp_elevation/configuration.json": 95109,
	"./resources/assignments/en/colligative/bp_elevation/reactions": 82947,
	"./resources/assignments/en/colligative/bp_elevation/reactions.json": 82947,
	"./resources/assignments/en/colligative/bp_elevation/solutions": 8935,
	"./resources/assignments/en/colligative/bp_elevation/solutions.json": 8935,
	"./resources/assignments/en/colligative/bp_elevation/species": 42117,
	"./resources/assignments/en/colligative/bp_elevation/species.json": 42117,
	"./resources/assignments/en/colligative/bp_elevation/spectra": 15759,
	"./resources/assignments/en/colligative/bp_elevation/spectra.json": 15759,
	"./resources/assignments/en/colligative/solution_nonaq/assignment": 64017,
	"./resources/assignments/en/colligative/solution_nonaq/assignment.json": 64017,
	"./resources/assignments/en/colligative/solution_nonaq/configuration": 54698,
	"./resources/assignments/en/colligative/solution_nonaq/configuration.json": 54698,
	"./resources/assignments/en/colligative/solution_nonaq/reactions": 90476,
	"./resources/assignments/en/colligative/solution_nonaq/reactions.json": 90476,
	"./resources/assignments/en/colligative/solution_nonaq/solutions": 47968,
	"./resources/assignments/en/colligative/solution_nonaq/solutions.json": 47968,
	"./resources/assignments/en/colligative/solution_nonaq/species": 40126,
	"./resources/assignments/en/colligative/solution_nonaq/species.json": 40126,
	"./resources/assignments/en/colligative/solution_nonaq/spectra": 70016,
	"./resources/assignments/en/colligative/solution_nonaq/spectra.json": 70016,
	"./resources/assignments/en/colligative/vapor_pressure/assignment": 15962,
	"./resources/assignments/en/colligative/vapor_pressure/assignment.json": 15962,
	"./resources/assignments/en/colligative/vapor_pressure/configuration": 95671,
	"./resources/assignments/en/colligative/vapor_pressure/configuration.json": 95671,
	"./resources/assignments/en/colligative/vapor_pressure/reactions": 4985,
	"./resources/assignments/en/colligative/vapor_pressure/reactions.json": 4985,
	"./resources/assignments/en/colligative/vapor_pressure/solutions": 13317,
	"./resources/assignments/en/colligative/vapor_pressure/solutions.json": 13317,
	"./resources/assignments/en/colligative/vapor_pressure/species": 70675,
	"./resources/assignments/en/colligative/vapor_pressure/species.json": 70675,
	"./resources/assignments/en/colligative/vapor_pressure/spectra": 44365,
	"./resources/assignments/en/colligative/vapor_pressure/spectra.json": 44365,
	"./resources/assignments/en/default/assignment": 91801,
	"./resources/assignments/en/default/assignment.json": 91801,
	"./resources/assignments/en/default/configuration": 65250,
	"./resources/assignments/en/default/configuration.json": 65250,
	"./resources/assignments/en/default/reactions": 22068,
	"./resources/assignments/en/default/reactions.json": 22068,
	"./resources/assignments/en/default/solutions": 53960,
	"./resources/assignments/en/default/solutions.json": 53960,
	"./resources/assignments/en/default/species": 12678,
	"./resources/assignments/en/default/species.json": 12678,
	"./resources/assignments/en/default/spectra": 25016,
	"./resources/assignments/en/default/spectra.json": 25016,
	"./resources/assignments/en/hotcoldpack/assignment": 42974,
	"./resources/assignments/en/hotcoldpack/assignment.json": 42974,
	"./resources/assignments/en/hotcoldpack/configuration": 26467,
	"./resources/assignments/en/hotcoldpack/configuration.json": 26467,
	"./resources/assignments/en/hotcoldpack/reactions": 32117,
	"./resources/assignments/en/hotcoldpack/reactions.json": 32117,
	"./resources/assignments/en/hotcoldpack/solutions": 94545,
	"./resources/assignments/en/hotcoldpack/solutions.json": 94545,
	"./resources/assignments/en/hotcoldpack/species": 40063,
	"./resources/assignments/en/hotcoldpack/species.json": 40063,
	"./resources/assignments/en/hotcoldpack/spectra": 82937,
	"./resources/assignments/en/hotcoldpack/spectra.json": 82937,
	"./resources/assignments/en/iron_thiocyanate/assignment": 14318,
	"./resources/assignments/en/iron_thiocyanate/assignment.json": 14318,
	"./resources/assignments/en/iron_thiocyanate/configuration": 31827,
	"./resources/assignments/en/iron_thiocyanate/configuration.json": 31827,
	"./resources/assignments/en/iron_thiocyanate/reactions": 87717,
	"./resources/assignments/en/iron_thiocyanate/reactions.json": 87717,
	"./resources/assignments/en/iron_thiocyanate/solutions": 62945,
	"./resources/assignments/en/iron_thiocyanate/solutions.json": 62945,
	"./resources/assignments/en/iron_thiocyanate/species": 99215,
	"./resources/assignments/en/iron_thiocyanate/species.json": 99215,
	"./resources/assignments/en/iron_thiocyanate/spectra": 41321,
	"./resources/assignments/en/iron_thiocyanate/spectra.json": 41321,
	"./resources/assignments/en/kinetics/cv_bleaching/assignment": 66080,
	"./resources/assignments/en/kinetics/cv_bleaching/assignment.json": 66080,
	"./resources/assignments/en/kinetics/cv_bleaching/configuration": 77141,
	"./resources/assignments/en/kinetics/cv_bleaching/configuration.json": 77141,
	"./resources/assignments/en/kinetics/cv_bleaching/reactions": 78291,
	"./resources/assignments/en/kinetics/cv_bleaching/reactions.json": 78291,
	"./resources/assignments/en/kinetics/cv_bleaching/solutions": 34199,
	"./resources/assignments/en/kinetics/cv_bleaching/solutions.json": 34199,
	"./resources/assignments/en/kinetics/cv_bleaching/species": 7189,
	"./resources/assignments/en/kinetics/cv_bleaching/species.json": 7189,
	"./resources/assignments/en/kinetics/cv_bleaching/spectra": 65983,
	"./resources/assignments/en/kinetics/cv_bleaching/spectra.json": 65983,
	"./resources/assignments/en/kinetics/iodide_persulfate/assignment": 7541,
	"./resources/assignments/en/kinetics/iodide_persulfate/assignment.json": 7541,
	"./resources/assignments/en/kinetics/iodide_persulfate/configuration": 25798,
	"./resources/assignments/en/kinetics/iodide_persulfate/configuration.json": 25798,
	"./resources/assignments/en/kinetics/iodide_persulfate/reactions": 56328,
	"./resources/assignments/en/kinetics/iodide_persulfate/reactions.json": 56328,
	"./resources/assignments/en/kinetics/iodide_persulfate/solutions": 45404,
	"./resources/assignments/en/kinetics/iodide_persulfate/solutions.json": 45404,
	"./resources/assignments/en/kinetics/iodide_persulfate/species": 55786,
	"./resources/assignments/en/kinetics/iodide_persulfate/species.json": 55786,
	"./resources/assignments/en/kinetics/iodide_persulfate/spectra": 22364,
	"./resources/assignments/en/kinetics/iodide_persulfate/spectra.json": 22364,
	"./resources/assignments/en/kinetics/k1/assignment": 93245,
	"./resources/assignments/en/kinetics/k1/assignment.json": 93245,
	"./resources/assignments/en/kinetics/k1/configuration": 48254,
	"./resources/assignments/en/kinetics/k1/configuration.json": 48254,
	"./resources/assignments/en/kinetics/k1/reactions": 97840,
	"./resources/assignments/en/kinetics/k1/reactions.json": 97840,
	"./resources/assignments/en/kinetics/k1/solutions": 10660,
	"./resources/assignments/en/kinetics/k1/solutions.json": 10660,
	"./resources/assignments/en/kinetics/k1/species": 13330,
	"./resources/assignments/en/kinetics/k1/species.json": 13330,
	"./resources/assignments/en/kinetics/k1/spectra": 68372,
	"./resources/assignments/en/kinetics/k1/spectra.json": 68372,
	"./resources/assignments/en/kinetics/k2/assignment": 99914,
	"./resources/assignments/en/kinetics/k2/assignment.json": 99914,
	"./resources/assignments/en/kinetics/k2/configuration": 11559,
	"./resources/assignments/en/kinetics/k2/configuration.json": 11559,
	"./resources/assignments/en/kinetics/k2/reactions": 80009,
	"./resources/assignments/en/kinetics/k2/reactions.json": 80009,
	"./resources/assignments/en/kinetics/k2/solutions": 40565,
	"./resources/assignments/en/kinetics/k2/solutions.json": 40565,
	"./resources/assignments/en/kinetics/k2/species": 90531,
	"./resources/assignments/en/kinetics/k2/species.json": 90531,
	"./resources/assignments/en/kinetics/k2/spectra": 73021,
	"./resources/assignments/en/kinetics/k2/spectra.json": 73021,
	"./resources/assignments/en/kinetics/k3/assignment": 45979,
	"./resources/assignments/en/kinetics/k3/assignment.json": 45979,
	"./resources/assignments/en/kinetics/k3/configuration": 11892,
	"./resources/assignments/en/kinetics/k3/configuration.json": 11892,
	"./resources/assignments/en/kinetics/k3/reactions": 38746,
	"./resources/assignments/en/kinetics/k3/reactions.json": 38746,
	"./resources/assignments/en/kinetics/k3/solutions": 34190,
	"./resources/assignments/en/kinetics/k3/solutions.json": 34190,
	"./resources/assignments/en/kinetics/k3/species": 3172,
	"./resources/assignments/en/kinetics/k3/species.json": 3172,
	"./resources/assignments/en/kinetics/k3/spectra": 85990,
	"./resources/assignments/en/kinetics/k3/spectra.json": 85990,
	"./resources/assignments/en/kinetics/k4equilibrium/assignment": 37492,
	"./resources/assignments/en/kinetics/k4equilibrium/assignment.json": 37492,
	"./resources/assignments/en/kinetics/k4equilibrium/configuration": 10017,
	"./resources/assignments/en/kinetics/k4equilibrium/configuration.json": 10017,
	"./resources/assignments/en/kinetics/k4equilibrium/reactions": 71967,
	"./resources/assignments/en/kinetics/k4equilibrium/reactions.json": 71967,
	"./resources/assignments/en/kinetics/k4equilibrium/solutions": 2627,
	"./resources/assignments/en/kinetics/k4equilibrium/solutions.json": 2627,
	"./resources/assignments/en/kinetics/k4equilibrium/species": 401,
	"./resources/assignments/en/kinetics/k4equilibrium/species.json": 401,
	"./resources/assignments/en/kinetics/k4equilibrium/spectra": 53179,
	"./resources/assignments/en/kinetics/k4equilibrium/spectra.json": 53179,
	"./resources/assignments/en/kinetics/k5/assignment": 80897,
	"./resources/assignments/en/kinetics/k5/assignment.json": 80897,
	"./resources/assignments/en/kinetics/k5/configuration": 96378,
	"./resources/assignments/en/kinetics/k5/configuration.json": 96378,
	"./resources/assignments/en/kinetics/k5/reactions": 55388,
	"./resources/assignments/en/kinetics/k5/reactions.json": 55388,
	"./resources/assignments/en/kinetics/k5/solutions": 97232,
	"./resources/assignments/en/kinetics/k5/solutions.json": 97232,
	"./resources/assignments/en/kinetics/k5/species": 41134,
	"./resources/assignments/en/kinetics/k5/species.json": 41134,
	"./resources/assignments/en/kinetics/k5/spectra": 78672,
	"./resources/assignments/en/kinetics/k5/spectra.json": 78672,
	"./resources/assignments/en/metals/assignment": 85450,
	"./resources/assignments/en/metals/assignment.json": 85450,
	"./resources/assignments/en/metals/configuration": 2663,
	"./resources/assignments/en/metals/configuration.json": 2663,
	"./resources/assignments/en/metals/reactions": 31241,
	"./resources/assignments/en/metals/reactions.json": 31241,
	"./resources/assignments/en/metals/solutions": 75445,
	"./resources/assignments/en/metals/solutions.json": 75445,
	"./resources/assignments/en/metals/species": 88611,
	"./resources/assignments/en/metals/species.json": 88611,
	"./resources/assignments/en/metals/spectra": 71101,
	"./resources/assignments/en/metals/spectra.json": 71101,
	"./resources/assignments/en/oracle-1/assignment": 96006,
	"./resources/assignments/en/oracle-1/assignment.json": 96006,
	"./resources/assignments/en/oracle-1/configuration": 24731,
	"./resources/assignments/en/oracle-1/configuration.json": 24731,
	"./resources/assignments/en/oracle-1/reactions": 95421,
	"./resources/assignments/en/oracle-1/reactions.json": 95421,
	"./resources/assignments/en/oracle-1/solutions": 46617,
	"./resources/assignments/en/oracle-1/solutions.json": 46617,
	"./resources/assignments/en/oracle-1/species": 78279,
	"./resources/assignments/en/oracle-1/species.json": 78279,
	"./resources/assignments/en/oracle-1/spectra": 45489,
	"./resources/assignments/en/oracle-1/spectra.json": 45489,
	"./resources/assignments/en/oracle-2/assignment": 98297,
	"./resources/assignments/en/oracle-2/assignment.json": 98297,
	"./resources/assignments/en/oracle-2/configuration": 16322,
	"./resources/assignments/en/oracle-2/configuration.json": 16322,
	"./resources/assignments/en/oracle-2/reactions": 7732,
	"./resources/assignments/en/oracle-2/reactions.json": 7732,
	"./resources/assignments/en/oracle-2/solutions": 9800,
	"./resources/assignments/en/oracle-2/solutions.json": 9800,
	"./resources/assignments/en/oracle-2/species": 98886,
	"./resources/assignments/en/oracle-2/species.json": 98886,
	"./resources/assignments/en/oracle-2/spectra": 472,
	"./resources/assignments/en/oracle-2/spectra.json": 472,
	"./resources/assignments/en/oracle-2_2/assignment": 45266,
	"./resources/assignments/en/oracle-2_2/assignment.json": 45266,
	"./resources/assignments/en/oracle-2_2/configuration": 37183,
	"./resources/assignments/en/oracle-2_2/configuration.json": 37183,
	"./resources/assignments/en/oracle-2_2/reactions": 88593,
	"./resources/assignments/en/oracle-2_2/reactions.json": 88593,
	"./resources/assignments/en/oracle-2_2/solutions": 15421,
	"./resources/assignments/en/oracle-2_2/solutions.json": 15421,
	"./resources/assignments/en/oracle-2_2/species": 58731,
	"./resources/assignments/en/oracle-2_2/species.json": 58731,
	"./resources/assignments/en/oracle-2_2/spectra": 90325,
	"./resources/assignments/en/oracle-2_2/spectra.json": 90325,
	"./resources/assignments/en/oracle-3/assignment": 13816,
	"./resources/assignments/en/oracle-3/assignment.json": 13816,
	"./resources/assignments/en/oracle-3/configuration": 94269,
	"./resources/assignments/en/oracle-3/configuration.json": 94269,
	"./resources/assignments/en/oracle-3/reactions": 53931,
	"./resources/assignments/en/oracle-3/reactions.json": 53931,
	"./resources/assignments/en/oracle-3/solutions": 17999,
	"./resources/assignments/en/oracle-3/solutions.json": 17999,
	"./resources/assignments/en/oracle-3/species": 94765,
	"./resources/assignments/en/oracle-3/species.json": 94765,
	"./resources/assignments/en/oracle-3/spectra": 13575,
	"./resources/assignments/en/oracle-3/spectra.json": 13575,
	"./resources/assignments/en/oracle-3_2/assignment": 24379,
	"./resources/assignments/en/oracle-3_2/assignment.json": 24379,
	"./resources/assignments/en/oracle-3_2/configuration": 23988,
	"./resources/assignments/en/oracle-3_2/configuration.json": 23988,
	"./resources/assignments/en/oracle-3_2/reactions": 45754,
	"./resources/assignments/en/oracle-3_2/reactions.json": 45754,
	"./resources/assignments/en/oracle-3_2/solutions": 28014,
	"./resources/assignments/en/oracle-3_2/solutions.json": 28014,
	"./resources/assignments/en/oracle-3_2/species": 40580,
	"./resources/assignments/en/oracle-3_2/species.json": 40580,
	"./resources/assignments/en/oracle-3_2/spectra": 15430,
	"./resources/assignments/en/oracle-3_2/spectra.json": 15430,
	"./resources/assignments/en/oracle-4/assignment": 70931,
	"./resources/assignments/en/oracle-4/assignment.json": 70931,
	"./resources/assignments/en/oracle-4/configuration": 24284,
	"./resources/assignments/en/oracle-4/configuration.json": 24284,
	"./resources/assignments/en/oracle-4/reactions": 77778,
	"./resources/assignments/en/oracle-4/reactions.json": 77778,
	"./resources/assignments/en/oracle-4/solutions": 51206,
	"./resources/assignments/en/oracle-4/solutions.json": 51206,
	"./resources/assignments/en/oracle-4/species": 60444,
	"./resources/assignments/en/oracle-4/species.json": 60444,
	"./resources/assignments/en/oracle-4/spectra": 55502,
	"./resources/assignments/en/oracle-4/spectra.json": 55502,
	"./resources/assignments/en/oracle-temp-1/assignment": 37433,
	"./resources/assignments/en/oracle-temp-1/assignment.json": 37433,
	"./resources/assignments/en/oracle-temp-1/configuration": 65058,
	"./resources/assignments/en/oracle-temp-1/configuration.json": 65058,
	"./resources/assignments/en/oracle-temp-1/reactions": 83924,
	"./resources/assignments/en/oracle-temp-1/reactions.json": 83924,
	"./resources/assignments/en/oracle-temp-1/solutions": 31752,
	"./resources/assignments/en/oracle-temp-1/solutions.json": 31752,
	"./resources/assignments/en/oracle-temp-1/species": 80870,
	"./resources/assignments/en/oracle-temp-1/species.json": 80870,
	"./resources/assignments/en/oracle-temp-1/spectra": 82744,
	"./resources/assignments/en/oracle-temp-1/spectra.json": 82744,
	"./resources/assignments/en/oracle-temp-2/assignment": 39974,
	"./resources/assignments/en/oracle-temp-2/assignment.json": 39974,
	"./resources/assignments/en/oracle-temp-2/configuration": 72635,
	"./resources/assignments/en/oracle-temp-2/configuration.json": 72635,
	"./resources/assignments/en/oracle-temp-2/reactions": 63965,
	"./resources/assignments/en/oracle-temp-2/reactions.json": 63965,
	"./resources/assignments/en/oracle-temp-2/solutions": 95033,
	"./resources/assignments/en/oracle-temp-2/solutions.json": 95033,
	"./resources/assignments/en/oracle-temp-2/species": 83367,
	"./resources/assignments/en/oracle-temp-2/species.json": 83367,
	"./resources/assignments/en/oracle-temp-2/spectra": 68529,
	"./resources/assignments/en/oracle-temp-2/spectra.json": 68529,
	"./resources/assignments/en/oracle-temp-2b/assignment": 16564,
	"./resources/assignments/en/oracle-temp-2b/assignment.json": 16564,
	"./resources/assignments/en/oracle-temp-2b/configuration": 35553,
	"./resources/assignments/en/oracle-temp-2b/configuration.json": 35553,
	"./resources/assignments/en/oracle-temp-2b/reactions": 37695,
	"./resources/assignments/en/oracle-temp-2b/reactions.json": 37695,
	"./resources/assignments/en/oracle-temp-2b/solutions": 34659,
	"./resources/assignments/en/oracle-temp-2b/solutions.json": 34659,
	"./resources/assignments/en/oracle-temp-2b/species": 34353,
	"./resources/assignments/en/oracle-temp-2b/species.json": 34353,
	"./resources/assignments/en/oracle-temp-2b/spectra": 44059,
	"./resources/assignments/en/oracle-temp-2b/spectra.json": 44059,
	"./resources/assignments/en/oracle-temp-3/assignment": 97543,
	"./resources/assignments/en/oracle-temp-3/assignment.json": 97543,
	"./resources/assignments/en/oracle-temp-3/configuration": 58344,
	"./resources/assignments/en/oracle-temp-3/configuration.json": 58344,
	"./resources/assignments/en/oracle-temp-3/reactions": 58622,
	"./resources/assignments/en/oracle-temp-3/reactions.json": 58622,
	"./resources/assignments/en/oracle-temp-3/solutions": 44770,
	"./resources/assignments/en/oracle-temp-3/solutions.json": 44770,
	"./resources/assignments/en/oracle-temp-3/species": 22376,
	"./resources/assignments/en/oracle-temp-3/species.json": 22376,
	"./resources/assignments/en/oracle-temp-3/spectra": 23226,
	"./resources/assignments/en/oracle-temp-3/spectra.json": 23226,
	"./resources/assignments/en/oracle-temp-3b/assignment": 6279,
	"./resources/assignments/en/oracle-temp-3b/assignment.json": 6279,
	"./resources/assignments/en/oracle-temp-3b/configuration": 3080,
	"./resources/assignments/en/oracle-temp-3b/configuration.json": 3080,
	"./resources/assignments/en/oracle-temp-3b/reactions": 28414,
	"./resources/assignments/en/oracle-temp-3b/reactions.json": 28414,
	"./resources/assignments/en/oracle-temp-3b/solutions": 67170,
	"./resources/assignments/en/oracle-temp-3b/solutions.json": 67170,
	"./resources/assignments/en/oracle-temp-3b/species": 66888,
	"./resources/assignments/en/oracle-temp-3b/species.json": 66888,
	"./resources/assignments/en/oracle-temp-3b/spectra": 6362,
	"./resources/assignments/en/oracle-temp-3b/spectra.json": 6362,
	"./resources/assignments/en/oracle-temp-4/assignment": 67396,
	"./resources/assignments/en/oracle-temp-4/assignment.json": 67396,
	"./resources/assignments/en/oracle-temp-4/configuration": 21201,
	"./resources/assignments/en/oracle-temp-4/configuration.json": 21201,
	"./resources/assignments/en/oracle-temp-4/reactions": 60879,
	"./resources/assignments/en/oracle-temp-4/reactions.json": 60879,
	"./resources/assignments/en/oracle-temp-4/solutions": 83763,
	"./resources/assignments/en/oracle-temp-4/solutions.json": 83763,
	"./resources/assignments/en/oracle-temp-4/species": 1505,
	"./resources/assignments/en/oracle-temp-4/species.json": 1505,
	"./resources/assignments/en/oracle-temp-4/spectra": 715,
	"./resources/assignments/en/oracle-temp-4/spectra.json": 715,
	"./resources/assignments/en/solids/solubility/assignment": 16657,
	"./resources/assignments/en/solids/solubility/assignment.json": 16657,
	"./resources/assignments/en/solids/solubility/configuration": 82602,
	"./resources/assignments/en/solids/solubility/configuration.json": 82602,
	"./resources/assignments/en/solids/solubility/reactions": 32844,
	"./resources/assignments/en/solids/solubility/reactions.json": 32844,
	"./resources/assignments/en/solids/solubility/solutions": 26848,
	"./resources/assignments/en/solids/solubility/solutions.json": 26848,
	"./resources/assignments/en/solids/solubility/species": 73406,
	"./resources/assignments/en/solids/solubility/species.json": 73406,
	"./resources/assignments/en/solids/solubility/spectra": 72672,
	"./resources/assignments/en/solids/solubility/spectra.json": 72672,
	"./resources/assignments/en/solids/solubilityLargeHeat/assignment": 81176,
	"./resources/assignments/en/solids/solubilityLargeHeat/assignment.json": 81176,
	"./resources/assignments/en/solids/solubilityLargeHeat/configuration": 6365,
	"./resources/assignments/en/solids/solubilityLargeHeat/configuration.json": 6365,
	"./resources/assignments/en/solids/solubilityLargeHeat/reactions": 17707,
	"./resources/assignments/en/solids/solubilityLargeHeat/reactions.json": 17707,
	"./resources/assignments/en/solids/solubilityLargeHeat/solutions": 56367,
	"./resources/assignments/en/solids/solubilityLargeHeat/solutions.json": 56367,
	"./resources/assignments/en/solids/solubilityLargeHeat/species": 8461,
	"./resources/assignments/en/solids/solubilityLargeHeat/species.json": 8461,
	"./resources/assignments/en/solids/solubilityLargeHeat/spectra": 73351,
	"./resources/assignments/en/solids/solubilityLargeHeat/spectra.json": 73351,
	"./resources/assignments/en/solubility/assignment": 93438,
	"./resources/assignments/en/solubility/assignment.json": 93438,
	"./resources/assignments/en/solubility/configuration": 17347,
	"./resources/assignments/en/solubility/configuration.json": 17347,
	"./resources/assignments/en/solubility/reactions": 23573,
	"./resources/assignments/en/solubility/reactions.json": 23573,
	"./resources/assignments/en/solubility/solutions": 86001,
	"./resources/assignments/en/solubility/solutions.json": 86001,
	"./resources/assignments/en/solubility/species": 91519,
	"./resources/assignments/en/solubility/species.json": 91519,
	"./resources/assignments/en/solubility/spectra": 34393,
	"./resources/assignments/en/solubility/spectra.json": 34393,
	"./resources/assignments/en/study/assignment": 85177,
	"./resources/assignments/en/study/assignment.json": 85177,
	"./resources/assignments/en/study/configuration": 64674,
	"./resources/assignments/en/study/configuration.json": 64674,
	"./resources/assignments/en/study/reactions": 17076,
	"./resources/assignments/en/study/reactions.json": 17076,
	"./resources/assignments/en/study/solutions": 41672,
	"./resources/assignments/en/study/solutions.json": 41672,
	"./resources/assignments/en/study/species": 90310,
	"./resources/assignments/en/study/species.json": 90310,
	"./resources/assignments/en/study/spectra": 82840,
	"./resources/assignments/en/study/spectra.json": 82840,
	"./resources/assignments/en/test/assignment": 37926,
	"./resources/assignments/en/test/assignment.json": 37926,
	"./resources/assignments/en/test/configuration": 93659,
	"./resources/assignments/en/test/configuration.json": 93659,
	"./resources/assignments/en/test/reactions": 4733,
	"./resources/assignments/en/test/reactions.json": 4733,
	"./resources/assignments/en/test/solutions": 18873,
	"./resources/assignments/en/test/solutions.json": 18873,
	"./resources/assignments/en/test/species": 42343,
	"./resources/assignments/en/test/species.json": 42343,
	"./resources/assignments/en/test/spectra": 90737,
	"./resources/assignments/en/test/spectra.json": 90737,
	"./resources/assignments/es/default/assignment": 14444,
	"./resources/assignments/es/default/assignment.json": 14444,
	"./resources/assignments/es/default/configuration": 31785,
	"./resources/assignments/es/default/configuration.json": 31785,
	"./resources/assignments/es/default/reactions": 56599,
	"./resources/assignments/es/default/reactions.json": 56599,
	"./resources/assignments/es/default/solutions": 74395,
	"./resources/assignments/es/default/solutions.json": 74395,
	"./resources/assignments/es/default/species": 5705,
	"./resources/assignments/es/default/species.json": 5705,
	"./resources/assignments/es/default/spectra": 37763,
	"./resources/assignments/es/default/spectra.json": 37763,
	"./resources/assignments_chemv_en": 67223,
	"./resources/assignments_chemv_en.json": 67223,
	"./resources/assignments_en": 10057,
	"./resources/assignments_en.json": 10057,
	"./resources/assignments_es": 10074,
	"./resources/assignments_es.json": 10074,
	"./resources/glassware": 60824,
	"./resources/glassware.js": 60824,
	"./resources/lang": 41297,
	"./resources/lang.js": 41297,
	"./resources/reactions": 42333,
	"./resources/reactions.js": 42333,
	"./resources/solutions": 62113,
	"./resources/solutions.js": 62113,
	"./resources/species": 53783,
	"./resources/species.js": 53783,
	"./resources/tools": 69062,
	"./resources/tools.js": 69062,
	"./resources/vessels": 33226,
	"./resources/vessels.js": 33226,
	"./templates/1000mLBeaker.ejs": 22212,
	"./templates/1000mLFlask.ejs": 67935,
	"./templates/1000mLVolumetricFlask.ejs": 16287,
	"./templates/100mLBottle.ejs": 35476,
	"./templates/100mLGraduatedCylinder.ejs": 1627,
	"./templates/100mLVolumetricFlask.ejs": 80809,
	"./templates/10mLGraduatedCylinder.ejs": 98865,
	"./templates/10mLPipette.ejs": 56459,
	"./templates/2500mLBottle.ejs": 88146,
	"./templates/250mLBeaker.ejs": 78338,
	"./templates/250mLFlask.ejs": 26577,
	"./templates/250mLStopperedFlask.ejs": 22591,
	"./templates/250mLVolumetricFlask.ejs": 38049,
	"./templates/25mLGraduatedCylinder.ejs": 53657,
	"./templates/25mLPipette.ejs": 89059,
	"./templates/3LCarboy.ejs": 58648,
	"./templates/500mLFlask.ejs": 2973,
	"./templates/500mLVolumetricFlask.ejs": 89173,
	"./templates/50mLBurette.ejs": 6935,
	"./templates/50mLGraduatedCylinder.ejs": 53101,
	"./templates/5mLPipette.ejs": 56781,
	"./templates/600mLBeaker.ejs": 31025,
	"./templates/App.ejs": 5427,
	"./templates/Assignment.ejs": 90969,
	"./templates/AssignmentTextModal.ejs": 19075,
	"./templates/DisposablePipette.ejs": 18401,
	"./templates/InstrumentPanel.ejs": 36745,
	"./templates/LanguageModal.ejs": 90843,
	"./templates/Modal.ejs": 15345,
	"./templates/Nav.ejs": 14021,
	"./templates/RenameWorkbenchModal.ejs": 74950,
	"./templates/Stockroom.ejs": 55629,
	"./templates/TipsModal.ejs": 76083,
	"./templates/Vessel.ejs": 20612,
	"./templates/Workbench.ejs": 65273,
	"./templates/assignmentModal.ejs": 70316,
	"./templates/bunsenBurner.ejs": 45227,
	"./templates/foamCup.ejs": 25831,
	"./templates/scale.ejs": 13268,
	"./templates/solidBottle.ejs": 35091,
	"./templates/weighBoat.ejs": 3772,
	"./torus/TorusMessager": 36923,
	"./torus/TorusMessager.js": 36923,
	"./unknownacid1": 88293,
	"./unknownacid1.js": 88293,
	"./util/clamp": 16627,
	"./util/clamp.js": 16627,
	"./util/helpers": 2917,
	"./util/helpers.js": 2917,
	"./util/logger": 85718,
	"./util/logger.js": 85718,
	"./views/App": 62933,
	"./views/App.js": 62933,
	"./views/App.js~": 78545,
	"./views/Assignment": 48481,
	"./views/Assignment.js": 48481,
	"./views/InstrumentPanel": 78583,
	"./views/InstrumentPanel.js": 78583,
	"./views/Nav": 64967,
	"./views/Nav.js": 64967,
	"./views/Nav.js~": 43995,
	"./views/Stockroom": 16171,
	"./views/Stockroom.js": 16171,
	"./views/Stockroom.js~": 50447,
	"./views/Tool": 64610,
	"./views/Tool.js": 64610,
	"./views/Vessel": 51674,
	"./views/Vessel.js": 51674,
	"./views/Workbench": 20663,
	"./views/Workbench.js": 20663,
	"./views/replaceUnknowns": 80485,
	"./views/replaceUnknowns.js": 80485,
	"./views/replaceUnknowns.test": 3780,
	"./views/replaceUnknowns.test.js": 3780
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43993;